<template>
  <div v-if="btnShow" class="OrderManageList-root">
    <div v-if="authority" class="operations-btns">
      <a-space>
        <a-dropdown>
          <a-menu slot="overlay" @click="handlePlaceOrder">
            <a-menu-item :key="PlaceOrderType.SINGLE">下单</a-menu-item>
            <a-menu-item :key="PlaceOrderType.MULTIPLE">批量导入下单</a-menu-item>
          </a-menu>
          <a-button
            v-auth="$_ButtonPermission.ORDER_ORDERONLINE"
            v-track-click="{ trackName: '订单-纯运输订单-在线下单' }"
            type="primary"
          >
            在线下单 <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </a-space>
    </div>

    <div v-if="authority" class="search-pane">
      <a-tabs v-model="currentTab">
        <a-tab-pane v-for="tab in OrderProgressTabMap" :key="tab.key" :tab="tab.title" />
      </a-tabs>
      <pro-search
        ref="search"
        :open="openMore"
        :fileds="SearchFiled"
        :form="queryForm"
        @search="handleSerch"
        @reset="handleReset"
      >
        <template slot="orderType">
          <select-search
            v-if="orderStatusOptions.length > 0"
            ref="selectDom"
            :list="typeList"
            :current-tab="currentTabOrder"
            @onSearch="filterGoodsCategoryOptions"
            @checkedList="checkedList"
          >
          </select-search>
        </template>
        <template slot="serviceProvider">
          <serviceSelect
            ref="serviceSelect"
            :only-select="false"
            @change="handleChange"
          ></serviceSelect>
        </template>
        <template slot="projectId">
          <select-dom
            v-model="queryForm.projectId"
            :list="ProjectList"
            :select-all="selectAll"
            @onSearch="onSearchProject"
          />
        </template>
      </pro-search>
    </div>

    <div v-if="authority" class="table-content">
      <a-button
        v-auth="$_ButtonPermission.ORDER_BATCHCANCEL"
        :class="batchCancel"
        type="primary"
        :disabled="selectedOrders.length === 0"
        @click="cancelOrderMultiple"
      >
        批量取消
      </a-button>
      <a-button
        v-if="currentTab === 'CANCEL'"
        v-auth="$_ButtonPermission.ORDER_BATCHDELETE"
        :class="batchDelete"
        type="primary"
        :disabled="selectedOrders.length === 0"
        @click="cancelOrderDelete"
      >
        批量删除
      </a-button>
      <a-button
        v-track-click="{ trackName: '纯运输-导出订单' }"
        v-auth="$_ButtonPermission.ORDER_ORDEREXPORT"
        class="goodsSelectStyle"
        @click="orderExport"
        >导出订单</a-button
      >
      <a-table
        :columns="tableColums"
        :data-source="orderList"
        class="table-multip"
        :scroll="{ x: 'calc(700px + 50%)' }"
        :loading="isLoadingTable"
        :pagination="pagination"
        :row-selection="{
          onSelect: handleRowSelect,
          onSelectAll: handleRowSelectAll,
          getCheckboxProps: rowSelect,
          onChange,
          selectedRowKeys: selectedRowKeys,
        }"
        @change="handleTableChange"
      >
        <!-- 订单号 -->
        <template slot="odrNo" slot-scope="text, rowData">
          <span
            v-if="
              rowData.odrChannel === liuheOrderChannel ||
              rowData.odrChannel === seaOrderChannel
            "
          >
            {{ rowData.unifyOdrNo }}
          </span>
          <p v-else class="textLine">
            <a @click="checkDetail(rowData)">{{ rowData.unifyOdrNo }}</a>
          </p>
          <span v-if="rowData.odrChannel === seaOrderChannel" class="sea_tran">海运</span>
          <p v-if="rowData.crmNumber" class="fontstyle">
            <span class="wai">外</span>{{ rowData.crmNumber }}
          </p>
        </template>
        <!-- 订单状态 -->
        <template slot="statusText" slot-scope="text, rowData">
          <div v-if="rowData.negotiationType === NEGOTIABLE" class="lineDiv yijia">
            <p class="lineStyle yijiaStyle">议价单</p>
            <!-- <img src="@/assets/img/label_yijia.png" alt=""> -->
          </div>
          <status-tag :type="rowData.textType" :desc="rowData.expCalReason" :text="filterText(text)"></status-tag>
          <a-tooltip v-if="sensitiveFields.includes(findKeyByValue(orderSensitiveFields, '运营项目'))" placement="top">
            <template slot="title">
              <p>
                {{ rowData.projectName }}
              </p>
            </template>
            <p class="address-txt-min testStyle">
              {{ rowData.projectName }}
            </p>
          </a-tooltip>
        </template>
        <!-- 货物信息 -->
        <template slot="goosInfo" slot-scope="text, rowData">
          <p class="ellipsis1">{{ rowData.goodsInfoFistLine }}</p>
          <p>{{ rowData.goodsInfoSecondLine }}</p>
        </template>
        <!-- 起始地信息 -->
        <template slot="startAddress" slot-scope="text, rowData">
          <div v-if="rowData.startStations && rowData.startStations.length">
            <p class="address-txt">
              {{
                rowData.startStations[0].stationName ||
                rowData.startStations[0].stationAddress
              }}
              {{ rowData.startStations.length > 1 ? ' 等' : '' }}
            </p>
            <div v-if="rowData.startStations.length > 1">
              <p class="phoneStyle">
                共
                <span class="addressNumber">{{ rowData.startStations.length }}</span>
                个发货地
              </p>
            </div>
            <p v-if="rowData.startStations.length === 1" class="phoneStyle">
              <template v-if="rowData.ext && rowData.ext.demoData">
                {{
                  rowData.startStations[0].contactName
                    ? rowData.startStations[0].contactName.slice(0, 1) + '**'
                    : '--'
                }}
                {{
                  rowData.startStations[0].contactPhone
                    ? rowData.startStations[0].contactPhone.slice(0, 3) +
                      '****' +
                      rowData.startStations[0].contactPhone.slice(
                        rowData.startStations[0].contactPhone.length - 4,
                        rowData.startStations[0].contactPhone.length
                      )
                    : '--'
                }}
              </template>
              <template v-else>
                {{ rowData.startStations[0].contactName || '--' }}
                {{ rowData.startStations[0].contactPhone || '--' }}
              </template>
            </p>
          </div>
        </template>
        <!-- 目的地信息 -->
        <template slot="endAddress" slot-scope="text, rowData">
          <div v-if="rowData.isLine" class="lineDiv">
            <a-tooltip v-if="rowData.isLine" placement="top">
              <template slot="title">
                <span>{{ rowData.lineName }}</span>
              </template>
                <p class="lineStyle">
                  {{ rowData.lineName }}
                </p>
            </a-tooltip>
          </div>
          <div v-if="rowData.endStations && rowData.endStations.length">
            <p class="address-txt">
              {{
                rowData.endStations[0].stationName ||
                rowData.endStations[0].stationAddress
              }}
              {{ rowData.endStations.length > 1 ? ' 等' : '' }}
            </p>
            <div v-if="rowData.endStations.length > 1">
              <p class="phoneStyle">
                共
                <span class="addressNumber">{{ rowData.endStations.length }}</span>
                个收货地
              </p>
            </div>
            <p v-if="rowData.endStations.length === 1" class="phoneStyle">
              <template v-if="rowData.ext && rowData.ext.demoData">
                {{
                  rowData.endStations[0].contactName
                    ? rowData.endStations[0].contactName.slice(0, 1) + '**'
                    : '--'
                }}
                {{
                  rowData.endStations[0].contactPhone
                    ? rowData.endStations[0].contactPhone.slice(0, 3) +
                      '****' +
                      rowData.endStations[0].contactPhone.slice(
                        rowData.endStations[0].contactPhone.length - 4,
                        rowData.endStations[0].contactPhone.length
                      )
                    : '--'
                }}
              </template>
              <template v-else>
                {{ rowData.endStations[0].contactName }}
                {{ rowData.endStations[0].contactPhone }}
              </template>
            </p>
          </div>
        </template>
        <!-- 订单总金额 -->
        <template slot="orderAmount" slot-scope="text, rowData">
          <div v-if="rowData.status === UnifyOrderStatusKey.BIDDING">
            <span v-if="filterBidding(rowData)">--</span>
            <div>
              <p>
                <span>我的出价：</span
                ><span>{{ rowData.negotiationBid.customerBidCost || '--' }}</span>
              </p>
              <p>
                <span>司机出价：</span
                ><span>{{ rowData.negotiationBid.driverBidCostTax || '--' }}</span>
              </p>
            </div>
          </div>
          <span v-else-if="rowData.cost" class="moneyStyle">
            {{ rowData.cost }}
          </span>
          <span v-else class="order-amount">暂未计算</span>
        </template>
        <!-- 派车信息 -->
        <template slot="dispatchInfo" slot-scope="text, rowData">
          <span v-if="rowData.dispatchInfo.carsNum === 0">--</span>
          <div v-else-if="rowData.dispatchInfo.carsNum === 1">
            <p>{{ rowData.dispatchInfo.firstLine }}</p>
            <p>{{ rowData.dispatchInfo.secondLine }}</p>
          </div>
          <span v-else>
            共<a @click="checkCarInfo(rowData)"> {{ rowData.dispatchInfo.carsNum }} </a>辆
          </span>
        </template>
        <!-- 下单信息 -->
        <template slot="createTime" slot-scope="text, rowData">
          <p>{{ rowData.createUserName }}</p>
          <span>{{ text }}</span>
        </template>
        <!-- 操作栏 -->
        <span slot="action" slot-scope="text, rowData">
          <!-- v-if="showEditButton(rowData.status, rowData.odrChannel)" -->
          <!-- 平台议价中 -->
          <template
            v-if="
              (!rowData.ext || !rowData.ext.demoData) &&
              rowData.odrChannel !== seaOrderChannel &&
              rowData.odrChannel !== liuheOrderChannel &&
              rowData.status !== 'FOR_CREDIT'
            "
          >
            <a
              v-if="rowData.confirmReceiptFlag"
              class="action-btn"
              type="link"
              @click="transportBidReceipt(rowData)"
            >
              确认收货
            </a>
            <a
              v-if="showSuccess(rowData)"
              class="action-btn"
              type="link"
              @click="transportBidConfirm(rowData)"
            >
              同意报价
            </a>
            <a
              v-if="showOffer(rowData)"
              class="action-btn removeStyle"
              type="link"
              @click="toDetail(rowData)"
            >
              重新出价
            </a>
            <!-- 多装多卸不允许编辑 -->
            <a
              v-if="showEditButton(rowData.status, rowData.odrChannel)"
              v-track-click="{ trackName: '纯运输-编辑' }"
              class="action-btn"
              type="link"
              @click="editOrder(rowData, false)"
            >
              编辑
            </a>
            <a
              v-if="rowData.odrChannel != 27"
              v-auth="$_ButtonPermission.ORDER_AGAIN"
              v-track-click="{
                trackName: `订单-纯运输订单-${
                  OrderProgressTabMap.find((t) => t.key === currentTab).title
                }-再来一单`,
              }"
              class="action-btn"
              type="link"
              @click="editOrder(rowData, true)"
            >
              再来一单
            </a>
            <!-- <a v-auth="$_ButtonPermission.ORDER_GROUP" class="action-btn" type="link" @click="checkSeriesData(rowData)"
              >查看同组</a> -->
            <a
              v-if="rowData.status === UnifyOrderStatusKey.SIGNED"
              v-track-click="{
                trackName: `订单-纯运输订单-${
                  OrderProgressTabMap.find((t) => t.key === currentTab).title
                }-查看回单`,
              }"
              class="action-btn"
              type="link"
              @click="seeReceipt(rowData)"
              >查看回单</a
            >
            <!-- 非平台询价中 -->
            <a
              v-if="
                rowData.status === UnifyOrderStatusKey.CARRIER_BIDDING &&
                rowData.cost !== null &&
                rowData.cost !== 0
              "
              v-track-click="{ trackName: '纯运输-同意报价' }"
              class="action-btn"
              type="link"
              @click="bidConfirm(rowData)"
              >同意报价</a
            >
            <a
              v-if="showCancelButton(rowData.status)"
              v-track-click="{ trackName: '纯运输-取消' }"
              class="action-btn removeStyle"
              type="link"
              @click="cancelOrder(rowData)"
            >
              取消
            </a>
          </template>
        </span>
      </a-table>
    </div>
    <div v-else class="noAuthority">暂未对个人货主开放，敬请期待</div>
    <a-modal
      class="create-list-wrap"
      title="选择下单产品"
      :visible="createVisible"
      :footer="null"
      centered
      :mask-closable="false"
      @cancel="createVisible = false"
    >
      <p
        v-for="item in createList"
        :key="item.productCode"
        class="create-list-item"
        @click="toStandardOrder(item.productCode)"
      >
        <i :class="getIcon(item.productCode)"></i>
        {{ item.productName }}
      </p>
    </a-modal>
    <!-- 选择合同及条款 -->
    <select-contract
      v-if="this.$store.state.user.customerId"
      ref="SelectContract"
      @success="successContract"
    ></select-contract>
    <!-- 查看回单 -->
    <image-dom ref="imageDom"></image-dom>
    <offer-dom
      v-if="toOffer"
      :detail="orderDetail"
      @cancel="toOffer = false"
      @update="tofetch"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapMutations, mapActions } from 'vuex';
import baseApi from '@/api/base.js';
import { RULE_TYPE } from '@/constants/ruleConfig';
import { EventBus } from '@/utils/event-bus';
import SelectDom from '@/components/select/SelectDom';
import setScrollTop from '@/utils/scroll';
import StatusTag from '@/components/tag/StatusTag.vue';
import textType from '@/components/tag/constants.js';
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue';
import ProSearch from '@/components/TableSearch/index.vue';
import orderSensitiveFields from '@/config/orderSensitiveFields';
import { postTrack } from '@/utils/point';
import {
  unifyList,
  cancelOrderUnify,
  orderExportUnify,
  orderBatchDeletionUnify,
  fetchProject,
  getInterface,
  getContract,
  getPictures,
  bidConfirm,
  featchOrderDetailUnify,
  transportBidConfirm,
  transportBidReceipt, getRules,
} from '../api';
import { tableColums, SearchFiled } from './tableColums';
import SelectContract from '../components/SelectContract';
import {
  OrderStatusCode,
  OrderStatus,
  OrderProgressTabMap,
  // OrderProgressStatus,
  DetailTabs,
  UnifyOrderStatus,
  UnifyOrderStatusKey,
  biddingList,
} from '../constant';
import SelectSearch from './components/SelectSearch';
import ImageDom from '../components/ImageDom';
import OfferDom from '../components/OfferDom.vue';

const PlaceOrderType = {
  SINGLE: 'single', // 单个下单
  MULTIPLE: 'multiple', // 批量下单
};
const orderType = {
  ALL: 'UnifyStatus',
  DOING: 'UnifyStatus_process',
  FINISH: 'UnifyStatus_finish',
  CANCEL: 'UnifyStatus_cancel',
};

const iconClass = {
  CP001: 'iconzhengche', // 干线专车
  CP002: 'iconlingdan', // 干线零担
  CP003: 'iconxianlu', // 线路配
  CP004: 'icondianwei', // 点位配
};

const orderChannel = 19; // 小程序下单
const contractImport = 16; // 批量导入下单
const liuheOrderChannel = 6; // 六合订单
const seaOrderChannel = 25; // 海运订单

const CityList = ['市辖区', '县', '省直辖县级行政区划'];
const NEGOTIABLE = 'NEGOTIABLE';

export default {
  name: 'OrderManageList',
  components: {
    SelectSearch,
    SelectDom,
    SelectContract,
    ImageDom,
    StatusTag,
    OfferDom,
    serviceSelect,
    ProSearch,
  },
  data() {
    return {
      NEGOTIABLE,
      liuheOrderChannel,
      seaOrderChannel,
      selectedRowKeys: [],
      OrderStatusCode,
      OrderStatus,
      PlaceOrderType,
      orderSensitiveFields,
      OrderProgressTabMap,
      pageSize: 10,
      currentTab: OrderProgressTabMap[1].key,
      currentTabOrder: OrderProgressTabMap[1].key,
      orderRecords: [],
      goodsCategory: [],

      // 数据查询条件
      queryForm: {
        unifyNo: '',
        crmNumber: '',
        status: '',
        goodsProperty__IN: '',
        createTime__BETWEEN: [],
        startAddrs: '',
        endAddrs: '',
        projectId: null,
        createUserName: '',
      },
      associationOdrNo: '', // 订单组同组查询:同组订单号
      selectedOrders: [], // 选中的订单
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      isLoadingTable: false,
      tabsValue: 'ALL',
      typeList: [],
      openMore: true,
      ProjectList: [
        {
          value: '',
          label: '全部',
        },
      ],
      accountData: {},
      authority: true,
      btnShow: false,
      selectAll: true,
      allProjectData: [],
      orderStatusOptions: [],
      createVisible: false,
      createList: [],
      iconClass,
      standardList: [],
      imageList: [],
      UnifyOrderStatusKey,
      biddingList,
      toOffer: false,
      orderDetail: {},
      isPretend: true,
      isEnterprise: false,
    };
  },
  computed: {
    getIcon() {
      return (code) => {
        return `iconfont ${iconClass[code]}`;
      };
    },
    sensitiveFields() {
      return this.$store.state.orderRules?.sensitiveFields?.SENSITIVE_FIELDS
        ?.orderSensitiveFields || [];
    },
    SearchFiled() {
      const arr = []
      SearchFiled.forEach(e => {
        if (!this.isEnterprise && e.name === 'serviceProvider') return
        if (e.name === 'projectId' && !this.sensitiveFields.includes(this.findKeyByValue(orderSensitiveFields, '运营项目'))) return
        if (e.name === 'serviceProvider' && !this.sensitiveFields.includes(this.findKeyByValue(orderSensitiveFields, '服务商'))) return
        arr.push(e)
      })
      return arr;
    },
    tableColums(){
      const arr = []
      tableColums.forEach(e => {
        if (e.dataIndex === 'carrierTenantName' && !this.sensitiveFields.includes(this.findKeyByValue(orderSensitiveFields, '服务商'))) return
        if (e.dataIndex === 'orderAmount' && !this.sensitiveFields.includes(this.findKeyByValue(orderSensitiveFields, '订单金额'))) return
        arr.push(e)
      })
      return arr
    },
    // 表格数据
    orderList() {
      const orderList = this.orderRecords.map((item) => {
        // 处理货物信息数据
        let goodsName = '';
        let goodsSum = 0;
        let goodsUnit = '';
        let goodsTotalWeight = 0;
        let goodsTotalVolume = 0;
        const enLength = item.endStations.length;
        item.unifyOrderGoods.forEach((goodsItem, index, goods) => {
          if (enLength === 1 && goods.length === 1) {
            goodsName =
              item.endStations[0].orderGoodsType === 0 ? '1个货品' : goods[0].skuName;
            goodsSum = goods[0].number;
            goodsUnit = goods[0].ext?.goodsUnit || '';
            goodsTotalWeight = goods[0].weight;
            goodsTotalVolume = goods[0].volume;
          } else {
            goodsName = `${goods.length}个货品`;
            goodsSum += goodsItem.number || null;
            goodsUnit = '件';
            // goodsTotalWeight += goodsItem.weightTon ? goodsItem.weightTon : 0
            // goodsTotalVolume += goodsItem.volume ? goodsItem.volume : 0
          }
        });

        // 处理派车信息数据
        const cars = item.dispatchList || [];
        const { driverName = '', driverPhone = '' } = cars[0] || {};
        let firstLine = `${driverName || ''} ${driverPhone || ''}`;
        if (item.ext?.demoData) {
          firstLine = `${driverName.slice(0, 1)}师傅 ${driverPhone.slice(
            0,
            3
          )}****${driverPhone.slice(driverPhone.length - 4, driverPhone.length)}`;
        }
        const dispatchInfo = {
          firstLine,
          secondLine: cars[0]?.licensePlate,
          carsNum: cars.length,
        };
        const weight = this.formatFloatNum(goodsTotalWeight);
        const volume = this.formatFloatNum(goodsTotalVolume);
        const sum = this.formatFloatNum(goodsSum);
        return {
          ...item,
          key: item.unifyOdrNo,
          // statusText: OrderStatus[item.status],
          statusText: item.status,
          goodsInfoFistLine: sum ? `${goodsName} 共${sum}${goodsUnit}` : goodsName,
          goodsInfoSecondLine: this.filterSecondLine(weight, volume),
          createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
          orderAmount: item.transportPrice?.toFixed(2),
          dispatchInfo,
          textType: textType(item.status),
        };
      });
      return orderList;
    },
    batchCancel() {
      // eslint-disable-next-line no-nested-ternary
      return this.tabsValue === 'FINISH'
        ? 'btn-cancel btnhidden'
        : this.tabsValue === 'CANCEL'
        ? 'btn-cancel btnoverhidden'
        : 'btn-cancel';
    },
    batchDelete() {
      return this.tabsValue === 'CANCEL' ? 'btn-cancel' : 'btn-cancel btnhidden';
    },
  },
  watch: {
    async currentTab(newVal, oldVal) {
      postTrack(
        `订单-纯运输订单-${OrderProgressTabMap.find((t) => t.key === newVal).title}`
      );
      this.tabsValue = newVal;
      if (newVal !== oldVal) {
        this.orderStatusOptions = await this.getOrderTypeList(orderType[newVal]);
        this.currentTabOrder = newVal;
        // 切换tab时，需要清空查询数据
        this.initQueryForm();
        this.initPagination();
        this.selectedOrders = [];
        this.getOrderList();
        this.selectedRowKeys = [];
      }
    },
  },
  async created() {
    this.getOrderCrop(RULE_TYPE.sensitiveFields);
    const { creditCode } = this.$store.state.user;
    this.isEnterprise = !!creditCode;
    // this.authority = this.$store.state.user.companyType
    // 获取到按钮权限再渲染页面
    const buttonPermission = JSON.parse(localStorage.getItem('buttonPermission'));
    if (buttonPermission) {
      this.btnShow = true;
    }
    EventBus.$on('onLoad', () => {
      this.btnShow = true;
    });
    this.orderStatusOptions = await this.getOrderTypeList(orderType.DOING);
    await this.initQueryForm();
    await this.getCargoType();
    await this.getOrderList();
    EventBus.$on('searchOrderList', () => {
      this.handleSerch();
    });
    // 多装多卸白名单
    // const req = await getConfig({
    //     keys: 'support.multi.loading.customer',
    //     appId: 1002
    // })
    // const list = req.configs[0]?.value.split(',') || ''
    // if(list.includes(this.$store.state.user.customerCode)){
    //     this.isPretend = true
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((mv) => {
      const forms = from;
      if (forms.path !== '/order/detail') {
        setScrollTop();
        mv.initQueryForm();
        mv.initPagination();
        mv.getOrderList();
        setTimeout(() => {
          mv.getOrganization();
        }, 300);
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeDestroy() {
    EventBus.$off('searchOrderList');
  },
  methods: {
    ...mapMutations('user', ['SET_USER_DATA']),
    ...mapActions('orderRules', ['getOrderCrop']),
    async handleChange(value) {
      this.queryForm.carrierTenantName = value.carrierTenantName;
      this.queryForm.customerCode = value.customerCode;
      this.queryForm.projectId = '';
      await this.getOrganization(value.customerCode);
      this.getOrderList();
    },
    findKeyByValue(obj, v){
      let value = null
      Object.keys(obj).forEach(key => {
        if (obj[key] === v) {
          value = key
        }
      })
      return value
    },
    transportBidReceipt(rowData) {
      transportBidReceipt({
        unifyOdrNo: rowData.unifyOdrNo,
      }).then(() => {
        this.$message.success('确认收货成功');
        this.handleSerch();
      });
    },
    transportBidConfirm(rowData) {
      transportBidConfirm({
        unifyOdrNo: rowData.unifyOdrNo,
        bidId: rowData.negotiationBid.bidId,
      }).then(() => {
        this.$message.success('提交成功');
        this.handleSerch();
      });
    },
    async toDetail(rowData) {
      this.orderDetail = await featchOrderDetailUnify({
        unifyOdrNo: rowData.unifyOdrNo,
      });
      this.toOffer = true;
    },
    tofetch() {
      this.toOffer = false;
      this.handleSerch();
    },
    showOffer(rowData) {
      return (
        rowData.status !== UnifyOrderStatusKey.CANCELED &&
        rowData.negotiationBid &&
        (rowData.negotiationBid.bidStatus === biddingList.NO_BID ||
          rowData.negotiationBid.bidStatus === biddingList.DISABLED ||
          rowData.negotiationBid.bidStatus === biddingList.NORMAL_BID)
      );
    },
    showSuccess(rowData) {
      return (
        rowData.status !== UnifyOrderStatusKey.CANCELED &&
        rowData.negotiationBid &&
        rowData.negotiationBid.bidStatus === biddingList.NORMAL_BID
      );
    },
    filterBidding(rowData) {
      return (
        rowData.negotiationBid &&
        rowData.negotiationBid.bidStatus === biddingList.DISABLED
      );
    },
    bidConfirm(rowData) {
      bidConfirm(rowData.unifyOdrNo).then(() => {
        this.$message.success('提交成功');
        this.getOrderList();
      });
    },
    filterText(data) {
      return UnifyOrderStatus[data] || '';
    },
    filterFull(data) {
      const text = data.fullAddress;
      return text.replace(`${data.provinceName}${data.cityName}${data.countryName}`, '');
    },
    filterCity(city, provinceName) {
      if (CityList.includes(city)) {
        return `${provinceName}${city}`;
      }
      return city;
    },
    async seeReceipt(rowData) {
      const imageList = await getPictures({
        unifyOrderNo: rowData.unifyOdrNo,
      });
      if (imageList && imageList.length > 0) {
        this.imageList = imageList;
        this.$refs.imageDom.show(imageList);
      } else {
        this.$message.warning('暂无回单');
      }
    },
    successContract(data) {
      this.$router.push({
        path: '/order/create-single',
        query: data,
      });
    },
    filterSecondLine(weight, volume) {
      if (weight && volume) {
        return `共${weight}kg/${volume}M³`;
      }
      if (weight && !volume) {
        return `共${weight}kg`;
      }
      if (!weight && volume) {
        return `共${volume}M³`;
      }
      return '';
    },
    onSearchProject(value) {
      this.selectAll = false;
      if (value) {
        this.ProjectList = this.allProjectData.filter((e) => {
          return e.label.includes(value);
        });
      }
    },
    async getOrganization(code) {
      // const accountData = JSON.parse(localStorage.getItem('accountData'))
      const { userId, customers, customerCode, creditCode } = this.$store.state.user;
      const data = {
        accountId: userId,
        // relationOrgId: accountData?.id,
        // relationType: 'DOWN',
        // orgType: 'PROJECT',
        // accountType: 'CUSTOMER',
        // orgNameLike: value
        customerCodes:
          !code && creditCode
            ? customers.map((item) => item.customerCode)
            : [customerCode],
        source: 'OWN',
      };
      const records = await fetchProject(data);
      if (records && records.length > 0) {
        this.ProjectList = records.map((e) => {
          return {
            ...e,
            value: e.id,
            label: e.name || e.projectName,
          };
        });
        this.ProjectList.unshift({
          value: '',
          label: '全部',
        });
      } else {
        this.ProjectList = [];
      }
      this.allProjectData = this.ProjectList;
      // if(this.selectAll){
      //   this.allProjectData = this.ProjectList
      // }
    },
    async getOrderTypeList(type) {
      const typeList = await baseApi.getDictionary({
        status: 1,
        type,
      });
      const options = typeList.map((res) => ({
        label: res.dictionaryName,
        value: res.dictionaryCode,
      }));
      return options;
    },
    onChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    toSearch() {
      this.pagination.current = 1;
      this.handleSerch();
    },
    orderExport() {
      if (this.orderList.length <= 0) {
        this.$message.warning('暂无订单数据');
        return;
      }
      const data = this.fetchData();
      orderExportUnify(data).then(() => {
        EventBus.$emit('taskPopover');
      });
    },
    fetchData() {
      let reqData = this.filterEmptyKey(this.queryForm);
      reqData = {
        carrierTenantName: reqData.carrierTenantName,
        customerCode: reqData.customerCode,
        unifyOrderStatusList: reqData.status ? reqData.status.split(',') : '',
        unifyNo: reqData.unifyNo,
        skuName:
          reqData.goodsProperty__IN !== undefined ? reqData.goodsProperty__IN : null,
        unifyStartFullAddress: reqData.startAddrs,
        unifyEndFullAddress: reqData.endAddrs,
        crmNumber: reqData.crmNumber,
        projectId: reqData.projectId ? reqData.projectId : null,
        unifyStartTime: Number(reqData.createTime__BETWEEN[0]?.format('x')),
        unifyEndTime: Number(reqData.createTime__BETWEEN[1]?.format('x')),
        scene: ['TRANSPORT_ONLY'],
        createUserName: reqData.createUserName,
        bdstNumber:reqData.bdstNumber,
      };
      return reqData;
    },
    checkedList(data) {
      this.queryForm.status = data.length > 0 ? data.join(',') : '';
      this.getOrderList();
    },
    filterGoodsCategoryOptions(searchData) {
      if (searchData === '') {
        this.typeList = this.orderStatusOptions;
        return;
      }
      const arr = [];
      this.orderStatusOptions.forEach((e) => {
        if (e.label.includes(searchData)) {
          arr.push(e);
        }
      });
      this.typeList = arr;
    },
    searchType() {
      this.getCargoType();
    },
    showEditButton(status, channel) {
      const statuslist = [
        UnifyOrderStatusKey.EXP_CAL_STATUS,
        UnifyOrderStatusKey.SUBMITTED,
        UnifyOrderStatusKey.DRAFT,
      ];
      if (status !== undefined && status !== null) {
        return statuslist.includes(status.toString()) && channel !== orderChannel;
      }
      return false;
    },
    showCancelButton(status) {
      const statuslist = [
        UnifyOrderStatusKey.BIDDING,
        UnifyOrderStatusKey.EXP_CAL_STATUS,
        UnifyOrderStatusKey.SUBMITTED,
        UnifyOrderStatusKey.DRAFT,
        UnifyOrderStatusKey.DEAL,
        UnifyOrderStatusKey.CARRIER_BIDDING,
        UnifyOrderStatusKey.FAIL_CREDIT,
      ];
      if (status !== undefined && status !== null) {
        return statuslist.includes(status.toString());
      }
      return false;
    },
    handleSerch(form) {
      this.initPagination();
      this.queryForm = {
        ...this.queryForm,
        ...form,
      };
      this.associationOdrNo = '';
      this.getOrderList();
    },
    handleReset() {
      this.initQueryForm();
      this.initPagination();
      this.getOrderList();
      this.$refs.selectDom.reseData(this.tabsValue);
    },
    handleRowSelect(record, selected, selectedRows) {
      this.selectedOrders = selectedRows;
    },
    rowSelect() {
      return {
        props: {
          disabled: this.tabsValue === 'FINISH',
        },
      };
    },
    handleRowSelectAll(selected, selectedRows) {
      this.selectedOrders = selectedRows;
    },
    checkDetail(rowData) {
      this.$router.push({
        path: `/order/detail`,
        query: {
          odrNo: rowData.unifyOdrNo,
        },
      });
    },
    checkCarInfo(rowData) {
      this.$router.push({
        path: `/order/detail`,
        query: {
          odrNo: rowData.unifyOdrNo,
          detailTab: DetailTabs.CARINFO,
        },
      });
    },
    selectedCustomer(rowData) {
      // 企业视角需要替换header头
      const { customers } = this.$store.state.user;
      const selectCarrier = customers.filter(
        (item) => item.customerCode === rowData.tenantId
      )[0];
      const { tenantId, orgId, customerId, customerCode, customerName } = selectCarrier;
      const accountData = {
        id: orgId,
        identityId: customerCode,
      };
      localStorage.setItem('accountData', JSON.stringify(accountData));
      const selectCarriering = {
        tenantId,
        tenantName: rowData.carrierTenantName,
        customerId,
        customerCode,
        customerName,
      };
      Object.keys(selectCarriering).forEach((item) => {
        this.SET_USER_DATA([item, selectCarriering[item]]);
      });
    },
    async getEmialRules(rowData) {
      try {
        // this.showPureOrder = false;
        const res = await getRules(
            {
              customerCode: rowData.tenantId,
              carrierTenantId: rowData.carrierTenantId,
              processModuleCode: 'EMAIL_CREATE_ORDER',
            }
        )
        const rules = res?.currentRules;
        if (rules.length) {
          return true
        }
        return false
      }catch (e) {
        return false
      }
    },
    async editOrder(rowData, oneMoreOrder) {
      const isCreateByRule = await this.getEmialRules(rowData)
      if (rowData.productCode) {
        // 判断是否有编辑权限
        const { creditCode } = this.$store.state.user;
        if (creditCode) {
          this.selectedCustomer(rowData);
        }
        const res = await getInterface({});
        const standardType = res.map((e) => {
          return e.productCode;
        });
        if(!isCreateByRule){ // 不是规则创建
          if (!standardType.includes(rowData.productCode)) {
            if (oneMoreOrder) {
              this.$message.warning('产品不存在，请维护合同产品');
            } else {
              this.$message.warning('未找到相应合同产品，无法编辑');
            }
            return;
          }
        }

        const reqData = this.filterEmptyKey(this.queryForm);
        this.$router.push({
          // path: `/order/standard-edit`,
          path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
            customerCode: rowData.tenantId,
            productCode: rowData.productCode,
            createTime__BETWEEN: [
              Number(reqData.createTime__BETWEEN[0]?.format('x')),
              Number(reqData.createTime__BETWEEN[1]?.format('x')),
            ],
            oneMoreOrder: oneMoreOrder || '',
          },
        });
      } else {
        const reqData = this.filterEmptyKey(this.queryForm);
        if (rowData.odrChannel === contractImport) {
          this.$router.push({
            // path: `/order/edit`,
            path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
            query: {
              odrNo: rowData.unifyOdrNo,
              createTime__BETWEEN: [
                Number(reqData.createTime__BETWEEN[0]?.format('x')),
                Number(reqData.createTime__BETWEEN[1]?.format('x')),
              ],
              customerCode: rowData.tenantId,
              contractCode: rowData.contractCode,
              contractTermCode: rowData.contractTermCode,
              offContract: true,
              productCode: 'transport',
              oneMoreOrder: oneMoreOrder || '',
            },
          });
          return;
        }
        // 判断是否有相应的合同和条款
        const resList = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode || rowData.tenantId,
          status: 'ENABLED',
          needAllContracts: true,
        });
        const arr = resList.map((e) => {
          return e.contractCode;
        });
        if(!isCreateByRule){
          // 判读是否有相应的合同
          if (!arr.includes(rowData.contractCode)) {
            if (oneMoreOrder) {
              this.$message.warning('合同不存在，请维护合同');
            } else {
              this.$message.warning('无合同编辑');
            }
            return;
          }
          const tremList = resList.filter((e) => {
            return e.contractCode === rowData.contractCode;
          });
          const trem = tremList[0].contractTermInfo.map((e) => {
            return e.code;
          });
          // 一单一议不校验条款
          if (tremList[0].negotiationType !== 'NEGOTIABLE') {
            // 判断是否有相应的条款
            if (!trem.includes(rowData.contractTermCode)) {
              if (oneMoreOrder) {
                this.$message.warning('合同条款不存在，请维护合同条款');
              } else {
                this.$message.warning('无条款编辑');
              }
              return;
            }
          }
        }
        this.$router.push({
          // path: `/order/edit`,
          path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
            createTime__BETWEEN: [
              Number(reqData.createTime__BETWEEN[0]?.format('x')),
              Number(reqData.createTime__BETWEEN[1]?.format('x')),
            ],
            customerCode: rowData.tenantId,
            contractCode: rowData.contractCode,
            contractTermCode: rowData.contractTermCode,
            productCode: 'transport',
            oneMoreOrder: oneMoreOrder || '',
          },
        });
      }
    },
    cancelOrder(rowData) {
      const odrNos = [rowData.unifyOdrNo];
      this.$confirm({
        content: '该操作会整体取消整个订单下所有子订单？',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk: async () => {
          const res = await cancelOrderUnify({
            cancelReason: '货主端取消',
            cancelType: 'CANCEL_ALL',
            unifyOdrNos: odrNos,
          });
          setTimeout(() => {
            if (res && res.length > 2) {
              const list = JSON.parse(res);
              this.$message.error({
                content: (
                  <div>
                    <p>{list.length}个订单取消失败</p>
                    {this.getErr(list)}
                  </div>
                ),
              });
            } else {
              this.$message.success('取消成功');
            }
            this.getOrderList();
          }, 1000);
        },
      });
    },
    cancelOrderMultiple() {
      const liuheList = this.selectedOrders.filter(
        (item) => item.odrChannel === liuheOrderChannel
      );
      if (liuheList.length) {
        this.$message.warning('六合接口创建的订单暂不支持取消');
        return;
      }
      const odrNos = this.selectedOrders.map((item) => item.unifyOdrNo);
      this.$confirm({
        content: '该操作会整体取消整个订单下所有子订单？',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk: async () => {
          this.onCancleOrders(odrNos);
          this.selectedOrders = [];
          this.selectedRowKeys = [];
        },
      });
    },
    cancelOrderDelete() {
      const liuheList = this.selectedOrders.filter(
        (item) => item.odrChannel === liuheOrderChannel
      );
      if (liuheList.length) {
        this.$message.warning('六合接口创建的订单暂不支持删除');
        return;
      }
      const odrNos = this.selectedOrders.map((item) => item.unifyOdrNo);
      this.$confirm({
        content: `确定删除选中的${odrNos.length}个订单？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          this.onBatchDeletion({ unifyOrderNos: odrNos });
          this.selectedOrders = [];
          this.selectedRowKeys = [];
        },
      });
    },
    async onCancleOrders(odrNos) {
      const res = await cancelOrderUnify({
        cancelReason: '货主端取消',
        cancelType: 'CANCEL_ALL',
        unifyOdrNos: odrNos,
      });
      this.isLoadingTable = true;
      setTimeout(() => {
        if (res && res.length > 2) {
          const list = JSON.parse(res);
          this.$message.error({
            content: (
              <div>
                <p>{list.length}个订单取消失败</p>
                {this.getErr(list)}
              </div>
            ),
          });
        } else {
          this.$message.success('取消成功');
        }
        this.getOrderList();
      }, 1000);
    },
    getErr(list) {
      return list.map((item) => {
        return <p>{item}</p>;
      });
    },
    async onBatchDeletion(odrNos) {
      const res = await orderBatchDeletionUnify(odrNos);

      this.isLoadingTable = true;
      setTimeout(() => {
        this.$message.success(res);
        this.getOrderList();
      }, 2000);
    },
    async checkSeriesData(rowData) {
      this.associationOdrNo = rowData.unifyOdrNo;
      await this.getOrderList();
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.selectedRowKeys = [];
      this.selectedOrders = [];
      this.getOrderList();
    },

    initPagination() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
    },
    initQueryForm() {
      const arr = [];
      // OrderProgressStatus[this.currentTab].forEach((e) => {
      //   if (this.currentTab !== 'ALL' || e.val !== '9'){
      //     arr.push(e.val)
      //   }
      // })

      this.orderStatusOptions.forEach((e) => {
        arr.push(e.value);
      });
      this.queryForm = {
        status: arr.join(','),
        unifyNo: '',
        goodsProperty__IN: '',
        createTime__BETWEEN: [
          moment().subtract(30, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        crmNumber: '',
        startAddrs: '',
        endAddrs: '',
        projectId: '',
        createUserName: '',
      };
      this.associationOdrNo = '';
      setTimeout(() => {
        const { creditCode } = this.$store.state.user;
        if (creditCode && this.$refs.serviceSelect) {
          this.$refs.serviceSelect.handleReset();
        }
      }, 100);
    },
    async getCargoType() {
      this.goodsCategory = await baseApi.getDictionary({
        status: 1,
        type: 'publicGoods',
      });
    },
    async getOrderList() {
      const fetchData = this.fetchData();
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
      };
      this.isLoadingTable = true;
      try {
        const res = await unifyList(fetchData, params);
        this.orderRecords = res.records;
        this.pagination = {
          ...this.pagination,
          current: res.page,
          pageSize: res.size,
          total: res.total,
        };
      } finally {
        this.isLoadingTable = false;
      }
    },
    // 过滤掉空数组和空字符串
    // 比如 {name: 'mike', jobs: []} -> {name: 'mike'}
    filterEmptyKey(requestBody) {
      const newReqBody = Object.keys(requestBody).reduce((pre, key) => {
        const value = requestBody[key];
        const newData = pre;
        if (value !== null && value.length !== 0) {
          newData[key] = value;
        }
        return newData;
      }, {});
      return newReqBody;
    },

    deleteRecord(key) {
      this.dataSource = this.dataSource.filter((item) => item.key !== key);
      this.selectedRows = this.selectedRows.filter((item) => item.key !== key);
    },
    remove() {
      this.dataSource = this.dataSource.filter(
        (item) => this.selectedRows.findIndex((row) => row.key === item.key) === -1
      );
      this.selectedRows = [];
    },
    // 标准下单
    toStandardOrder(productCode) {
      this.createVisible = false;
      this.$router.push({
        path: '/order/standard-create-single',
        query: {
          productCode,
        },
      });
    },
    async handlePlaceOrder(e) {
      const { creditCode } = this.$store.state.user;
      if (creditCode && e.key === PlaceOrderType.MULTIPLE) {
        this.$router.push({
          path: '/order/create-multiple',
        });
        return;
      }
      if (e.key === PlaceOrderType.SINGLE) {
        this.$router.push({
          path: '/order/createOrder',
        });
      }
      if (e.key === PlaceOrderType.MULTIPLE) {
        const res = await getInterface({});
        // 标准批量导入
        if (res && res.length) {
          this.$router.push({
            path: '/order/create-multiple',
          });
        } else {
          // 非标准批量导入
          const resList = await getContract({
            cargoOwnerCode: this.$store.state.user.customerCode,
            status: 'ENABLED',
            needAllContracts: true,
          });
          if (resList.length <= 0) {
            this.$message.warning('未创建合同，无法下单');
            return;
          }
          // 一单一议不允许下单
          const negotiationType = resList.map((data) => data.negotiationType);
          if (negotiationType.includes('NEGOTIABLE')) {
            this.$message.warning('一单一议合同暂仅支持APP下单');
            return;
          }
          this.$router.push({
            path: '/order/create-multiple',
          });
        }
      }
    },
    formatFloatNum(num) {
      // eslint-disable-next-line no-nested-ternary
      return num === null || num === undefined
        ? ''
        : Number.isInteger(num)
        ? num
        : num.toFixed(4);
    },
  },
};
</script>

<style lang="less" scoped>
.OrderManageList-root {
  border: 0;
}
.operations-btns {
  text-align: right;
  margin-bottom: 20px;
}

.search-pane {
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.table-content {
  padding: 24px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 6px;
}
.btn-cancel {
  margin-bottom: 12px;
}
.form-row {
  // display: flex;
  // justify-content: space-between;
  .formTitle {
    text-align: right;
    padding-right: 16px;
    width: 100%;
    display: inline-block;
    font-size: 14px;
    color: #606266;
    line-height: 32px;
  }
}
.form-item:last-child {
  margin-right: 0;
}
.w-224 {
  // width: 224px;
  min-width: 150px;
  color: #171717;
}
.form-btns {
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
  margin-top: 10px;
}
.form-btn {
  margin-left: 20px;
}
.address-txt {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #171717;
  // font-weight: 600;
}
.address-txt-min {
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.action-btn {
  padding: 0 8px;
}
.removeStyle {
  color: #969799;
}
.order-amount {
  color: #999999;
}
/deep/ .ant-tabs-tab-active {
  font-weight: bold !important;
}
/deep/ .ant-table-column-title {
  font-weight: bold;
}
.btnhidden {
  visibility: hidden;
}
.btnoverhidden {
  display: none;
}
.search-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.moreData {
  height: 30px;
  // width: 200px;
  line-height: 50px;
  background-color: #fff;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
}
.nextForm {
  margin-top: 15px;
  height: 0;
  transition: all ease 0.2s;
  // overflow: hidden;
}
.nextFormActive {
  height: auto;
}
.wai {
  display: inline-block;
  width: 16px;
  height: 16px;
  color: #fff;
  background: #606266;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  margin-right: 4px;
  margin-top: 4px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .ant-calendar-picker {
  // width: 250px !important;
  max-width: 100%;
}
.fontstyle {
  font-size: 12px;
  color: #999999;
}
.textLine {
  text-decoration: underline;
}
.noAuthority {
  text-align: center;
  color: #ccc;
  background: #fff;
  height: calc(100vh - 200px);
  line-height: calc(100vh - 200px);
}
.testStyle {
  font-size: 12px;
  color: #969799;
}
.create-list-wrap {
  ::v-deep {
    .ant-modal-body {
      padding: 0;
    }
  }
}
.create-list-item {
  color: #666666;
  font-size: 14px;
  line-height: 44px;
  padding-left: 64px;
  .iconfont {
    margin-right: 10px;
    color: #999999;
  }
  &:hover {
    cursor: pointer;
    background: rgb(223, 247, 235);
    color: #06b880;
    .iconfont {
      color: #06b880;
    }
  }
}
.lineDiv {
  // height: 10px;
  text-align: right;
  // position: relative;
  // position: absolute;
  // right: 0;
  // top: 0;
}
.lineStyle {
  display: inline-block;
  color: #fb9432;
  padding: 0 9px;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  background-image: url('../../../assets/img/lineName.png');
  background-size: 100% 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  // position: absolute;
  // top: 0;
  // right: 0;
}
.yijiaStyle {
  display: inline-block;
  color: #06b880;
  background-image: url('../../../assets/img/label_yijia.png');
  width: 77px;
  height: 20px;
  text-align: right;
}
.addressNumber {
  display: inline-block;
  border: 1px solid #606266;
  padding: 0 4px;
  height: 17px;
  line-height: 14px;
  font-size: 12px;
  text-align: center;
  border-radius: 9px;
}
.goodsSelectStyle {
  float: right;
}
.phoneStyle {
  color: #969799;
}
.moneyStyle {
  color: #ed4934;
}
.orderName {
  margin-top: 16px;
}
.search_btn {
  color: #06b880;
  border-color: #06b880;
}
.sea_tran {
  padding: 0px 8px;
  background: #e8f4ff;
  color: #1890ff;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid #d1e9ff;
}
</style>
